import PortalClienteService from "services/bases/PortalClienteService";

class CotacaoService extends PortalClienteService{
    async ListarMotivosReprovacao(){
        return await this.get(`cotacao/ListarMotivosReprovacao`)
    }

    async ObterCotacao(cotacaoId){
        return await this.get(`cotacao/${cotacaoId}`)
    }

    async ReprovarCotacao(data){
        return await this.post(`cotacao/ReprovarCotacao`, data)
    }
    async AprovarCotacao(data){
        return await this.post(`cotacao/AprovarCotacao`, data)
    }
}

export default new CotacaoService();